import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import * as ELIcons from '@element-plus/icons'
import 'element-plus/dist/index.css'
import { createRouter, createWebHashHistory } from 'vue-router';

import { routes } from './router';


const app = createApp(App);

app.use(ElementPlus);
for (let i in ELIcons) {
    app.component("i-"+i.replace(/[A-Z]/g, m => '-' + m.toLowerCase()).substring(1), ELIcons[i]);
}
// app.use(VueRouter);
const router = createRouter({
    // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history: createWebHashHistory(),
    routes, // `routes: routes` 的缩写
})
app.use(router)
app.mount('#app');